export default __webpack_public_path__ + "static/media/instructor-5.43085084.webp";